export function formatDirectLastSeenDate(dateValue, locale, now = new Date()) {
  const dt = dateValue instanceof Date ? dateValue : new Date(dateValue);
  if (!Number.isFinite(dt.getTime())) return "";

  const includeYear = now.getFullYear() !== dt.getFullYear();
  const normalizedLocale = String(locale || "").trim().toLowerCase();

  if (["sk", "cs"].some((code) => normalizedLocale === code || normalizedLocale.startsWith(`${code}-`))) {
    const day = String(dt.getDate()).padStart(2, "0");
    const month = String(dt.getMonth() + 1).padStart(2, "0");
    return includeYear ? `${day}/${month}/${dt.getFullYear()}` : `${day}/${month}`;
  }

  return new Intl.DateTimeFormat(locale || undefined, {
    day: "numeric",
    month: "short",
    ...(includeYear ? { year: "numeric" } : {}),
  }).format(dt);
}

export function resolveDirectPeerPresenceUpdate(payload, peerUserId) {
  if (String(payload?.event || "").trim().toLowerCase() !== "presence.updated") {
    return null;
  }

  const payloadUserId = Number(payload?.user_id || 0);
  const expectedUserId = Number(peerUserId || 0);
  if (!payloadUserId || !expectedUserId || payloadUserId !== expectedUserId) {
    return null;
  }

  const isOnline = Boolean(payload?.is_online);
  return {
    is_online: isOnline,
    last_seen_at: payload?.last_seen_at || null,
    presence_expires_at: isOnline ? payload?.expires_at || null : null,
  };
}

export function getDirectPresenceExpiryDelay(expiresAt, nowMs = Date.now()) {
  if (!expiresAt) return null;
  const expiryMs = new Date(expiresAt).getTime();
  if (!Number.isFinite(expiryMs)) return null;
  return Math.max(0, expiryMs - Number(nowMs || 0) + 150);
}
